module.exports = ".mat-dialog-content{display:flex;flex-direction:column;max-width:400px}.mat-dialog-actions button{flex:1 1 auto;margin:0 15px}\n"